import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { ToolbarButton } from "./components/ToolbarButton.tsx";
import { ToolbarSeparator } from "./components/ToolbarSeparator.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import * as styles from "./Toolbar.style.ts";
import { observer } from "mobx-react-lite";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { IconButtonV2 } from "src/components/IconButtonV2/IconButtonV2.tsx";

export const Toolbar = observer(() => {
  const store = useExonnHubStore();
  const isShowFavorite = store.showFavorite;
  const isFullscreen = store.isFullscreen;

  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);
  const handleLikeButtonClick = () => {
    store.toggleShowFavorite();
  };

  const handleFilterButtonClick = () => {
    store.toggleFilterPanel();
  };

  const likeButtonHelperText = isShowFavorite
    ? t("specialFilters.favorites.reset")
    : t("specialFilters.favorites.enable");

  return (
    <div css={styles.root}>
      {/*{!isFilterPanelOpen && (*/}

      <ButtonV2
        css={styles.filterButton({
          isFullscreen,
        })}
        onClick={handleFilterButtonClick}
        startAdornment={<i className={"icon-15-filter"} />}
        size={"sm"}
        skin={"info"}
        variant={"outlined"}
      >
        {t("openFilterPanel")}
      </ButtonV2>
      <IconButtonV2
        css={styles.smallFilterButton({
          isFullscreen,
        })}
        onClick={handleFilterButtonClick}
        size={"sm"}
        skin={"info"}
        variant={"outlined"}
      >
        <i className={"icon-15-filter"} />
      </IconButtonV2>
      {/*)}*/}

      {/*<IconButtonV2*/}
      {/*  onClick={handleFilterButtonClick}*/}
      {/*  size={"sm"}*/}
      {/*  skin={"info"}*/}
      {/*  variant={"outlined"}*/}
      {/*>*/}
      {/*  <FilterIcon />*/}
      {/*</IconButtonV2>*/}

      <ToolbarSeparator />
      <TooltipV2 content={likeButtonHelperText}>
        <ToolbarButton
          isActive={isShowFavorite}
          onClick={handleLikeButtonClick}
        >
          {isShowFavorite ? (
            <i className="icon-fl-15-heart_f" />
          ) : (
            <i className="icon-15-heart" />
          )}
        </ToolbarButton>
      </TooltipV2>

      <ToolbarSeparator />
    </div>
  );
});
